// extracted by mini-css-extract-plugin
export default {"mainCard":"NextAppoinment_mainCard__BhURK","imgDiv":"NextAppoinment_imgDiv__xTl59"};